import S from 'shorti'
export default {
  input: {
    ...S('mb-20 bg-2e3f54 border-none color-fff h-60 font-21 color-9198A1'),
    outline: 'none'
  }
}


// WEBPACK FOOTER //
// ./src/components/Partials/EditBar/style.js